import type { HotelRoomOccupancyView } from '../models.js';

export const MAX_ROOMS = 5;
export const MAX_GUESTS_PER_ROOM = 3;
export const MAX_GUESTS = 9;

/** `key` é a identidade do quarto/vaga na tela: remover um não faz o seguinte
 *  herdar o nó (e o foco) dele. Nasce aqui e nunca sai no `onChange`. */
export type RoomSlot = { key: number; travelerId: string | undefined };

export type RoomState = {
  key: number;
  slots: RoomSlot[];
};

let lastKey = 0;
const nextKey = (): number => ++lastKey;

export const newSlot = (travelerId?: string): RoomSlot => ({ key: nextKey(), travelerId });

export const newRoom = (): RoomState => ({ key: nextKey(), slots: [newSlot()] });

export function distribute(
  rooms: readonly HotelRoomOccupancyView[],
  travelerIds: readonly string[],
): RoomState[] {
  const queue = travelerIds.slice(0, MAX_GUESTS);
  const sourceRooms = rooms.length > 0 ? rooms : [{ guests: 1 }];
  const roomCapacities = sourceRooms.slice(0, MAX_ROOMS).map((room) => ({
    guests: Math.min(MAX_GUESTS_PER_ROOM, Math.max(1, room.guests)),
  }));
  let missingCapacity = Math.max(
    0,
    queue.length - roomCapacities.reduce((total, room) => total + room.guests, 0),
  );

  for (const room of roomCapacities) {
    const added = Math.min(MAX_GUESTS_PER_ROOM - room.guests, missingCapacity);
    room.guests += added;
    missingCapacity -= added;
  }
  while (missingCapacity > 0 && roomCapacities.length < MAX_ROOMS) {
    const guests = Math.min(MAX_GUESTS_PER_ROOM, missingCapacity);
    roomCapacities.push({ guests });
    missingCapacity -= guests;
  }

  return roomCapacities.map((room) => ({
    key: nextKey(),
    slots: Array.from({ length: room.guests }, () => newSlot(queue.shift())),
  }));
}
